import { resizeObservers as r } from "./highrise1820.mjs";
var t = function() {
  return r.some(function(e) {
    return e.skippedTargets.length > 0;
  });
};
export {
  t as hasSkippedObservations
};
